import { useSelector } from "react-redux";
import {
  getAppraisalData,
  getQuestionsAndAnswers
} from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { sortAnswers } from "../../helpers";
function useKeysQuestion({ question }: { question: Question }) {
  const dispatch = useDispatch();
  const { questionValidation } = useSelector(getAppraisalData);
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  
  const sortedAnswers = sortAnswers(question.answers)

  const handleAnswerChange = (answerId: number) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    if (questionValidation) {
      dispatch(appraisalSlice.actions.setQuestionValidation(""));
    }
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({ [question.id]: [answerId] })
    );
  };

  return {
    error: questionValidation,
    handleChange: handleAnswerChange,
    storedAnswer,
    sortedAnswers
  };
}

export default useKeysQuestion;
